module.exports = __webpack_public_path__ + "img/18_17.5f5bfb95.png";